import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Col, LoaderMi, Row, SelectControl } from '@si-armes/dsfr-react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deleteAPI, getAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from '../../../store/usagerReducer';
import {
    API_DELETE_ALL_NOTIFICATIONS,
    API_DELETE_NOTIFICATION,
    API_GET_NOMBRE_NOTIFICATIONS,
    API_GET_NOTIFICATIONS,
    CONTEXT_DELETE_ALL_NOTIFICATIONS,
    CONTEXT_DELETE_NOTIFICATION,
    CONTEXT_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_GET_NOTIFICATIONS,
} from '../../../constants/apiUrls.constants';
import AfficherNotificationsDynamique from './components/AfficherNotificationsDynamique';
import {
    DATA_NOTIFICATION_SELECT_FILTRE,
    DATA_NOTIFICATION_SELECT_TRI_DATE,
} from './constants/notifications.constants';
import { formaterOptions } from '../../../utils/utils';

const RechercherNotifications = ({
    getApi,
    deleteApi,
    reinitialiseApi,
    isLoading,
    dataNotifications,
}) => {
    const { register, getValues, watch } = useForm({
        defaultValues: {
            TrierParDate: 'antechronologique',
            FiltrerParTypeNotifications: 'aucun',
        },
    });

    const [donneesNotifications, setDonneesNotifications] = useState([]);

    const recupererDernierIdNotifications = () => {
        const lastIndex =
            donneesNotifications && donneesNotifications.length > 0
                ? donneesNotifications.length - 1
                : 0;
        return donneesNotifications &&
            donneesNotifications.length > 0 &&
            donneesNotifications[lastIndex]
            ? donneesNotifications[lastIndex].id
            : 0;
    };

    const getApiNotifications = (dernierIdNotification) => {
        getApi(
            usagerClientReducer,
            `${API_GET_NOTIFICATIONS}?triDate=${getValues('TrierParDate')}&filtreTheme=${getValues(
                'FiltrerParTypeNotifications',
            )}&dernierIdNotification=${dernierIdNotification}`,
            CONTEXT_GET_NOTIFICATIONS,
        );
        // MAJ du nombre de notification après une suppression
        getApi(usagerClientReducer, API_GET_NOMBRE_NOTIFICATIONS, CONTEXT_GET_NOMBRE_NOTIFICATIONS);
    };

    // On mount
    // Revalider le tri date et le filtre thème et le nombre de notifs par page
    useEffect(() => {
        if (!isLoading) {
            getApiNotifications('0');
            setDonneesNotifications([]);
        }
    }, [watch('TrierParDate'), watch('FiltrerParTypeNotifications')]);

    useEffect(() => {
        if (dataNotifications) {
            reinitialiseApi(CONTEXT_GET_NOTIFICATIONS);
            if (Array.isArray(dataNotifications)) {
                setDonneesNotifications([...donneesNotifications, ...dataNotifications]);
            }
        }
    }, [dataNotifications]);

    const supprimerNotificationParId = (id) => {
        deleteApi(
            usagerClientReducer,
            `${API_DELETE_NOTIFICATION}${id}`,
            CONTEXT_DELETE_NOTIFICATION,
        );

        setDonneesNotifications(donneesNotifications.filter((notif) => notif.id !== id));

        // MAJ du nombre de notification après une suppression
        getApi(usagerClientReducer, API_GET_NOMBRE_NOTIFICATIONS, CONTEXT_GET_NOMBRE_NOTIFICATIONS);
    };

    const afficherPlusDeNotifications = () => {
        getApiNotifications(recupererDernierIdNotifications());
    };

    const supprimerToutesLesNotifications = () => {
        // supprimer un a un toutes les notifications affichées et supprimables avec leurs l'id
        deleteApi(
            usagerClientReducer,
            API_DELETE_ALL_NOTIFICATIONS,
            CONTEXT_DELETE_ALL_NOTIFICATIONS,
        );

        getApi(usagerClientReducer, API_GET_NOMBRE_NOTIFICATIONS, CONTEXT_GET_NOMBRE_NOTIFICATIONS);

        setDonneesNotifications([]);
        getApiNotifications('0');

        afficherPlusDeNotifications();
    };

    return (
        <div className="position-relative">
            {isLoading && <LoaderMi />}
            <h1>Notifications</h1>
            <Row gutters>
                <Col col={6} xl={4}>
                    <div>Trier</div>
                </Col>
                <Col col={6} xl={4}>
                    <div>Filtre</div>
                </Col>
            </Row>
            <Row gutters verticalAlign="bottom">
                <Col col={6} xl={4}>
                    <SelectControl
                        id="TrierParDate"
                        name="TrierParDate"
                        aria-label="Trier les notifications :"
                        label=""
                        options={formaterOptions(DATA_NOTIFICATION_SELECT_TRI_DATE)}
                        {...register('TrierParDate')}
                        placeholder="-- Choisir une option --"
                    />
                </Col>
                <Col col={6} xl={4}>
                    <SelectControl
                        id="FiltrerParTypeNotifications"
                        name="FiltrerParTypeNotifications"
                        label=""
                        aria-label="Filtrer les notifications par :"
                        options={formaterOptions(DATA_NOTIFICATION_SELECT_FILTRE)}
                        {...register('FiltrerParTypeNotifications')}
                        placeholder="-- Choisir une option --"
                    />
                </Col>
                <Col col={12} xl={4}>
                    <Button
                        type="submit"
                        variant="secondary"
                        onClick={supprimerToutesLesNotifications}
                    >
                        Supprimer les notifications supprimables
                    </Button>
                </Col>
            </Row>

            <br />

            {donneesNotifications && (
                <AfficherNotificationsDynamique
                    notifications={donneesNotifications}
                    supprimerNotificationParId={supprimerNotificationParId}
                />
            )}

            <div className="text-center margin-top-md">
                <Button onClick={afficherPlusDeNotifications} variant="secondary">
                    Afficher plus de notifications
                </Button>
            </div>
        </div>
    );
};

RechercherNotifications.propTypes = {
    getApi: PropTypes.func.isRequired,
    deleteApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataNotifications: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            description: PropTypes.string.isRequired,
            dateCreation: PropTypes.string.isRequired,
            themeNotification: PropTypes.string.isRequired,
            supprimable: PropTypes.bool.isRequired,
        }),
    ),
    isLoading: PropTypes.bool,
};

export default connect(
    (state) => {
        const { isLoading, data } = state.notification.notificationsUsager;
        return {
            dataNotifications: data,
            isLoading,
        };
    },
    {
        getApi: getAPI,
        deleteApi: deleteAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(RechercherNotifications);
